import * as api from './adapter';
import downloadFile from './downloadFile';

// Recruiting-bonus dashboard (CREW-1034). Talks to planvisor's plain-JSON
// `recruiting_metrics` endpoints (not JSON:API), so responses come back as
// the object our BE renders — unwrap the adapter's { data, headers }.
const unwrap = (promise) => promise.then((res) => res.data);

export default {
  getRecruiters: (query = {}) => unwrap(api.read('recruiting_metrics/recruiters', { query })),
  getSummary: (query = {}) => unwrap(api.read('recruiting_metrics/summary', { query })),
  getCoordination: (query = {}) => unwrap(api.read('recruiting_metrics/coordination', { query })),
  // The Looker dashboard's charts, moved in (CREW-1312 / 1313 / 1314).
  getCoordinationCharts: (query = {}) => unwrap(api.read('recruiting_metrics/coordination_charts', { query })),
  getResults: (query = {}) => unwrap(api.read('recruiting_metrics/results', { query })),
  getPromotion: (query = {}) => unwrap(api.read('recruiting_metrics/promotion', { query })),
  getCurrentTasks: (query = {}) => unwrap(api.read('recruiting_metrics/tasks_current', { query })),
  // CREW-1176 — the signed-in person's own worst tasks for the dashboard
  // widget. No client parameter on purpose: this is the personal dashboard.
  getMyTasks: (query = {}) => unwrap(api.read('recruiting_metrics/my_tasks', { query })),
  getOverdueDays: (query = {}) => unwrap(api.read('recruiting_metrics/overdue_days', { query })),
  getSettings: () => unwrap(api.read('recruiting_metrics/settings')),
  updateSettings: (attributes) =>
    unwrap(api.update({ controller: 'recruiting_metrics/settings', ...attributes })),
  getBonusReport: (query = {}) => unwrap(api.read('recruiting_metrics/bonus_report', { query })),
  getBonusHistory: (query = {}) => unwrap(api.read('recruiting_metrics/bonus_history', { query })),
  closeMonth: (month) => unwrap(api.create({ controller: 'recruiting_metrics/close_month', month })),
  downloadBonusReport: (month) => {
    const q = month ? `?month=${encodeURIComponent(month)}` : '';
    return downloadFile(`recruiting_metrics/bonus_report/download${q}`, `bonus-report${month ? `-${month}` : ''}.xlsx`);
  },
};
